import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import SplitRows from '../../components/general/SplitRow.js';
import OptionColumn from '../../components/general/OptionColumn.js';
import Notification from '../../components/Notification.js';
import Helmet from 'react-helmet';
import General from "../../helpers/General";
import GeneralFunctions from "../../modules/General";
import moment from "moment/moment";
import Confirm from "../../components/Confirm";

class SettingsUser extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			ip:'',
			'email_invite':'',
			apiKeys:[],
			blacklist:[],
			askDelete:false,
		}

		this.handleInviteInput = this.handleInviteInput.bind(this);
		this.handleSendInvite = this.handleSendInvite.bind(this);
		this.generateKey = this.generateKey.bind(this);

	}

	deleteUser(id) {
		this.setState({askDelete:false,isLoading:true});
		axios.delete('/users/'+id).then(res => {
			GeneralFunctions.fetchGeneral();
		});

	}

	handleInviteInput(e) {
		this.setState({'email_invite':e.target.value});
	}

	handleSendInvite(e) {
		e.stopPropagation();
		Notification.success("Sending...");

		if(this.state.email_invite == '') {
			Notification.error("E-mail address can't be empty.");
			return;
		}

		axios.post('/ajax/invite_new_user',{email:this.state.email_invite}).then(res => {
			Notification.success("Invitation sent to "+this.state.email_invite);
			this.setState({'email_invite':''});
		}).catch(error => {
			Notification.error('Error sending e-mail.. Invitation not sent.');
		});
	}

	getKeys() {
        axios.get('/api/keys').then(res => {
            this.setState({
                apiKeys:res.data
            });
        });
	}

	getBlacklist = () => {
		axios.get('/ip_blacklist').then(res => {
			this.setState({
				blacklist:res.data
			});
		});
	}

    generateKey() {
        axios.post('/api/keys').then(res => {
            this.setState({
                apiKeys:[
					...this.state.apiKeys,
					res.data
				]
            });
        });
	}

	componentWillMount() {
		this.getKeys();
		this.getBlacklist();
	}

	addIpToBlacklist = () => {
		if(this.state.ip == '') {
			Notification.error("Ip can't be empty.");
			return;
		}

		if(!this.validateIp(this.state.ip)) {
			Notification.error("Invalid IP-address.");
			return;
		}

		let ip = this.state.ip;

		this.setState({
			ip:'',
		});

		axios.post('/ip_blacklist',{
			ip:ip
		}).then(res => {
			Notification.success("The IP has been added.");

			let blacklist = [
				...this.state.blacklist,
				res.data,
			];

			this.setState({
				blacklist:blacklist
			})

		});


	}

	validateIp(ipaddress) {
		if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipaddress)) {
			return (true)
		}

		return false;
	}

	removeIp = (index,id) => {
		let blacklist = [...this.state.blacklist.slice(0, index), ...this.state.blacklist.slice(index + 1)];
		this.setState({
			blacklist:blacklist
		})
		axios.delete('/ip_blacklist/'+id);
	}

	askDeleteUser = (id) => {
		this.setState({askDelete:id});
	}

	handleIpChange = (e) => {
		this.setState({
			ip:e.target.value,
		});
	}

	render() {

		return (
			<div className="full-height">
				<Helmet title="Users | Crall.io" />
				<div className="page-header">
					<span className="page-title"><i className="icon wb-users"></i> Users</span>
				</div>

				<div className="page-content">

					<OptionColumn title="Invite new user" description="Send an e-mail invitation to a new user.">
						<div className="form-group col-sm-12">
                            <label className="control-label">New users e-mail address</label>
                            <input type="text" className="form-control" value={this.state.email_invite} onChange={this.handleInviteInput} placeholder="user@example.com" />
                        </div>
                        <div className="form-group col-sm-12">
                        	<button className="btn btn-dark btn-block" onClick={this.handleSendInvite}><i className="icon fa fa-paper-plane"></i> Send invite</button>
						</div>
					</OptionColumn>

					<SplitRows />

					<OptionColumn title="Existing users" description="Manage existing users">
						<ul className="list-group list-group-full">
							{this.props.general.users.map((user,i) => {
								return (
									<li key={i} className="list-group-item">
											<div className="media">
												<div className="media-left">
												<a className="avatar" href="javascript:void(0)">
													<img className="img-fluid" src={user.image} alt="..." />
												</a>
												</div>
												<div className="media-body">
													<h4 className="media-heading">{user.firstname} {user.lastname}</h4>
													<small>{user.email}</small>
												</div>
												<div className="media-right">
													{
														user.id != this.props.auth.user.id ?
														<div className="btn-group" role="group">
															<button onClick={() => this.askDeleteUser(user.id)} type="button" className="btn btn-icon btn-default btn-outline">
																<i className="icon wb-trash" aria-hidden="true"></i>
															</button>
														</div>:null
													}
												</div>
										</div>
									</li>
								)
							})}

						</ul>
					</OptionColumn>

                    <SplitRows />

                    <OptionColumn title="API" description="Manage and generate API-keys">
						{this.state.apiKeys.length > 0 ?
                            <table className="table table-striped">
                                <thead>
                                <tr>
                                    <th>Key</th>
                                    <th>Last accessed</th>
                                    <th>Created</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.apiKeys.map((key,i) => {
                                    return (
                                        <tr key={i}>
                                            <td style={{width:'50%'}}>{key.token}</td>
                                            <td>{!key.last_accessed ? 'Never':moment(General.toLocalTime(key.last_accessed)).fromNow()}</td>
                                            <td>{moment(General.toLocalTime(key.created_at)).fromNow()}</td>
                                        </tr>
                                    )
                                })}

                                </tbody></table>:null}

                                <button onClick={this.generateKey} className="btn btn-dark pull-right">Generate key</button>
                    </OptionColumn>

					<SplitRows />

					<OptionColumn title="Blacklist" description="Ip-addresses that should be excluded from Crall">
						{this.state.blacklist.length > 0 ?
							<table className="table table-striped">
								<thead>
								<tr>
									<th>Ip</th>
									<th>Date added</th>
									<th></th>
								</tr>
								</thead>
								<tbody>
								{this.state.blacklist.map((key,i) => {
									return (
										<tr key={i}>
											<td style={{width:'50%'}}>{key.ip}</td>
											<td>{moment(General.toLocalTime(key.created_at)).fromNow()}</td>
											<td>
												<div className="btn-group" role="group">
													<button type="button" onClick={() => {this.removeIp(i,key.id)}} className="btn btn-icon btn-default btn-outline">
														<i className="icon wb-trash" aria-hidden="true"></i>
													</button>
												</div>
											</td>
										</tr>
									)
								})}

								</tbody></table>:null}

						<div className="row">
							<div className="col-sm-8">
								<input type="text" value={this.state.ip} onChange={this.handleIpChange} placeholder="127.0.0.1" className="form-control" />
							</div>
							<div className="col-sm-4">
								<button onClick={this.addIpToBlacklist} className="btn btn-dark pull-right">Add IP to blacklist</button>
							</div>
						</div>
					</OptionColumn>

					<Confirm onAccept={(e) => { this.deleteUser(e) }} onClose={() => {this.setState({askDelete:false})}} param={this.state.askDelete} title="Are you sure?" body="Do you want to delete this user?" />

				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		auth:state.auth,
		general:state.general
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({},dispatch)
}


SettingsUser = connect(mapStateToProps,mapDispatchToProps)(SettingsUser);
export default SettingsUser;



// WEBPACK FOOTER //
// ./containers/settings/SettingsUsers.js